import { CarryOutOutlined, ControlOutlined, TagsOutlined, PieChartOutlined } from '@ant-design/icons';
import React, { createContext } from 'react';
import ApontamentoProducao from '../components/pages/ApontamentoProducao/index';
import BenefitOrderParametrization from '../components/pages/BenefitOrderParametrization';
import Dashboard from '../components/pages/Dashboard';
import Notification from '../components/pages/Notification';
import ParametrizacaoApp from '../components/pages/ParametrizacaoApp';
import PayrollDetails from '../components/pages/PayrollDetails';
import Payrolls from '../components/pages/Payrolls';
import PedidoBeneficio from '../components/pages/PedidoBeneficio';
import ReportUtilizacao from '../components/pages/ReportUtilizacao';
import { MODULE_BENEFIT_ORDER, MODULE_PAYROLL_ORDER } from './modules';
import InactiveCooperators from '../components/pages/InactiveCooperators';
import BenefitOrderList from '../components/pages/BenefitOrderList';
import PresetReport from '../components/pages/PresetReport';

export const modules = [
  {
    key: MODULE_PAYROLL_ORDER,
    icon: <CarryOutOutlined />,
    name: 'Apontamento de produção',
    defaultUrl: '/apontamento-producao',
    routes: [
      {
        name: 'Apontamento de Produção',
        path: '/apontamento-producao/:id?',
        // Necessário definir a URL separadamente para evitar a inclusão do :id na URL ao acessar a rota pelo menu
        url: '/apontamento-producao',
        exact: true,
        element: <ApontamentoProducao />,
        shouldDisplayOnMenu: true,
        requiredPermissions: [{ action: 'view', subject: 'payroll' }],
      },
      {
        name: 'Parametrização',
        path: '/apontamento/parametrizar/:id?',
        url: '/apontamento/parametrizar',
        exact: true,
        element: <ParametrizacaoApp />,
        shouldDisplayOnMenu: true,
        requiredPermissions: [
          { action: 'list', subject: 'payroll.parameterization' },
          { action: 'view', subject: 'payroll.parameterization' },
        ],
      },
      {
        name: 'Relatório de Utilização',
        path: '/report-utilizacao',
        url: '/report-utilizacao',
        exact: true,
        element: <ReportUtilizacao />,
        shouldDisplayOnMenu: true,
        requiredPermissions: [{ action: 'view', subject: 'payroll.report.usage' }],
      },
      {
        name: 'Gerenciamento de Requisições',
        path: '/payrolls',
        url: '/payrolls',
        exact: true,
        element: <Payrolls />,
        shouldDisplayOnMenu: true,
        requiredPermissions: [{ action: 'list', subject: 'payroll' }],
      },
      {
        name: 'Detalhes da Requisição',
        path: '/payrolls/:id',
        url: '/payrolls/:id',
        exact: true,
        element: <PayrollDetails />,
        requiredPermissions: [{ action: 'view', subject: 'payroll' }],
      },
    ],
  },
  {
    key: MODULE_BENEFIT_ORDER,
    icon: <TagsOutlined />,
    name: 'Pedido de VA/VR',
    defaultUrl: '/benefits/create',
    routes: [
      {
        name: 'Pedido de VA/VR',
        path: '/benefits/create',
        url: '/benefits/create',
        exact: true,
        element: <PedidoBeneficio />,
        shouldDisplayOnMenu: true,
        requiredPermissions: [{ action: 'create', subject: 'benefit-order' }],
      },
      {
        name: 'Consulta de Pedidos',
        path: '/benefits',
        url: '/benefits',
        exact: true,
        element: <BenefitOrderList />,
        shouldDisplayOnMenu: true,
        requiredPermissions: [{ action: 'list', subject: 'benefit-order' }],
      },
      {
        name: 'Detalhes do pedido de benefício',
        path: '/benefits/:id',
        url: '/benefits/:id',
        exact: true,
        element: <PedidoBeneficio viewMode />,
        requiredPermissions: [{ action: 'view', subject: 'benefit-order' }],
      },
      {
        name: 'Parametrização',
        path: '/benefits/parametrization/:id?',
        url: '/benefits/parametrization',
        exact: true,
        element: <BenefitOrderParametrization />,
        shouldDisplayOnMenu: true,
        requiredPermissions: [{ action: 'view', subject: 'benefit-order.parameterization' }],
      },
    ],
  },
  {
    key: 'admin_dashboard',
    icon: <ControlOutlined />,
    name: 'Configurações do sistema',
    defaultUrl: '/notification',
    routes: [
      {
        name: 'Notificações',
        path: '/notification',
        url: '/notification',
        exact: true,
        element: <Notification />,
        shouldDisplayOnMenu: true,
        requiredPermissions: [{ action: 'create', subject: 'notification' }],
      },
    ],
  },
  {
    key: 'reports',
    icon: <PieChartOutlined />,
    name: 'Relatórios e Indicadores',
    defaultUrl: '/reports/preset',
    routes: [
      {
        name: 'Dashboard',
        path: '/reports/dashboard',
        url: '/reports/dashboard',
        exact: true,
        element: <Dashboard />,
        shouldDisplayOnMenu: true,
        requiredPermissions: [{ action: 'view', subject: 'report.payroll-value-bands' }],
      },
      {
        name: 'Relatórios Pré-Definidos',
        path: '/reports/preset',
        url: '/reports/preset',
        exact: true,
        element: <PresetReport />,
        shouldDisplayOnMenu: true,
        requiredPermissions: [{ action: 'view', subject: 'report.inactive-cooperator' }],
      },
      {
        name: 'Relatórios de Afastados',
        path: '/reports/inactive-cooperators',
        url: '/reports/inactive-cooperators',
        exact: true,
        element: <InactiveCooperators />,
        shouldDisplayOnMenu: false,
        requiredPermissions: [{ action: 'view', subject: 'report.inactive-cooperator' }],
      },
    ],
  },
];

export const SelectedModuleContext = createContext();

export function getAuthorizedModules(ability) {
  return modules.filter(({ routes }) => {
    const filteredRoutes = routes.filter(({ requiredPermissions, shouldDisplayOnMenu }) => {
      if (!shouldDisplayOnMenu) {
        return false;
      }

      return requiredPermissions && requiredPermissions.every(({ action, subject }) => ability.can(action, subject));
    });

    return filteredRoutes.length;
  });
}

export function getAuthorizedRoutes(ability) {
  const allRoutes = modules.flatMap(({ routes }) => routes);
  return allRoutes.filter(({ requiredPermissions }) => {
    if (requiredPermissions && requiredPermissions.length > 0) {
      return requiredPermissions.every(({ action, subject }) => ability.can(action, subject));
    }

    return true;
  });
}

export function getAuthorizedRoutesForSidebarMenu(ability, module) {
  return module.routes.filter(({ requiredPermissions, shouldDisplayOnMenu }) => {
    if (!shouldDisplayOnMenu) {
      return false;
    }

    if (requiredPermissions && requiredPermissions.length > 0) {
      return requiredPermissions.every(({ action, subject }) => ability.can(action, subject));
    }

    return true;
  });
}

export function getDefaultUrl(ability) {
  const [firstAuthorizedModule] = getAuthorizedModules(ability);
  if (firstAuthorizedModule) {
    return firstAuthorizedModule.defaultUrl;
  }

  return null;
}
